import { motion } from "framer-motion";
import { useStore } from "../context/StoreContext";

export const Manifesto = () => {
  const { t, img } = useStore();
  return (
    <section id="manifesto" className="bg-[#1C1917] text-[#EFEAE1] py-24 lg:py-36" data-testid="manifesto-section">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-14 xl:px-24">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="mb-20"
        >
          <p className="text-[11px] font-mono uppercase tracking-[0.3em] text-[#C85A32] mb-4 flex items-center gap-3">
            <span className="w-8 h-px bg-[#C85A32]" />
            {t.manifesto.overline}
          </p>
          <h2 className="font-serif text-3xl lg:text-4xl tracking-tight max-w-lg">{t.manifesto.title}</h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-px bg-[#EFEAE1]/10">
          {t.manifesto.chapters.map((c, i) => (
            <motion.div
              key={c.num}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.15 }}
              className="bg-[#1C1917] py-12 lg:px-10 first:lg:pl-0 last:lg:pr-0"
              data-testid={`manifesto-chapter-${c.num}`}
            >
              <span className="font-serif italic text-5xl text-[#C85A32]/60">{c.num}/</span>
              <h3 className="mt-6 font-serif text-2xl">{c.title}</h3>
              <p className="mt-4 text-sm text-[#EFEAE1]/60 leading-relaxed">{c.text}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1 }}
          className="mt-20 rounded-2xl overflow-hidden"
        >
          <img src={img("ritualTexture")} alt="Rituel cacao adaptogène" className="w-full h-[320px] lg:h-[440px] object-cover" />
        </motion.div>
      </div>
    </section>
  );
};
